
import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isHomePage = location.pathname === '/' || location.pathname === '';
  
  // Pages avec fond sombre (Hero avec image de fond)
  const hasDarkBackground = isHomePage || location.pathname === '/contact';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    if (isHomePage) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(`/#${id}`);
    }
  };

  const toggleLanguage = () => {
    const newLang = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
  };

  // Détermine la couleur du texte selon le contexte
  const getTextColor = () => {
    if (isScrolled) {
      return 'text-[#0A0A0A]';
    }
    // Sur les pages à fond clair, texte sombre dès le départ
    if (!hasDarkBackground) {
      return 'text-[#0A0A0A]';
    }
    // Sur les pages à fond sombre, texte blanc
    return 'text-white';
  };

  const textColorClass = getTextColor();

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white shadow-md' 
          : hasDarkBackground 
            ? 'bg-transparent' 
            : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-center">
        <div className="flex items-center gap-8">
          <button
            onClick={() => scrollToSection('hero')}
            className={`text-sm font-medium transition-colors cursor-pointer hover:text-[#0066FF] ${textColorClass}`}
          >
            {t('nav.home')}
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className={`text-sm font-medium transition-colors cursor-pointer hover:text-[#0066FF] ${textColorClass}`}
          >
            {t('nav.about')}
          </button>
          <Link
            to="/skills"
            className={`text-sm font-medium transition-colors cursor-pointer hover:text-[#0066FF] ${textColorClass}`}
          >
            {t('nav.skills')}
          </Link>
          <Link
            to="/projects"
            className={`text-sm font-medium transition-colors cursor-pointer hover:text-[#0066FF] ${textColorClass}`}
          >
            {t('nav.projects')}
          </Link>
          <Link
            to="/blog"
            className={`text-sm font-medium transition-colors cursor-pointer hover:text-[#0066FF] ${textColorClass}`}
          >
            {t('nav.blog')}
          </Link>
          <Link
            to="/contact"
            className={`text-sm font-medium transition-colors cursor-pointer hover:text-[#0066FF] ${textColorClass}`}
          >
            {t('nav.contact')}
          </Link>
          
          {/* Language Switcher */}
          <button
            onClick={toggleLanguage}
            className={`text-sm font-medium transition-colors cursor-pointer hover:text-[#0066FF] flex items-center gap-2 ${textColorClass}`}
          >
            <i className="ri-global-line text-lg"></i>
            {i18n.language === 'fr' ? 'EN' : 'FR'}
          </button>
        </div>
      </div>
    </nav>
  );
}
